function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtWhite = function SvgTtWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 50 51"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 49.9,
    height: 49.9,
    y: 0.6,
    rx: 24.9,
    ry: 24.9,
    style: {
      strokeWidth: 0,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 41.2c-.8-.1-1.1-.2-1.7-.4-4-1.3-6.5-4-7.2-8.2-.9-5.8 3.2-10.4 8-11.3 1.2-.2 2.3-.2 3.5 0v5.9c-.2 0-.4 0-.6-.1-2.2-.5-4.4.7-5.2 2.8s0 4.3 2 5.5c2.3 1.4 5.7.4 6.6-2.7.1-.5.1-1 .1-1.5v-22h5.2c.1.7.2 1.4.4 2.1.9 3 2.9 4.7 5.9 5.5.3 0 .6.1.9.2.3 0 .6 0 .9.1v5.4c-2.8 0-5.4-.9-7.7-2.5v11.3c-.1 4.2-2.2 7.3-6 9.1-.9.4-2.7.9-5 .8",
    style: {
      fill: "#717172",
      strokeWidth: 0
    }
  }));
};
export default SvgTtWhite;